import styled from "styled-components";

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
`;

export const WrapperIcon = styled.div`

`